const features = [
  {
    id: 1,
    title: '海量高清片库',
    desc: '超过 20,000 部电影资源，涵盖动作、科幻、悬疑、喜剧等全品类，满足各种观影口味',
    icon: 'ri-database-2-line',
    iconBg: 'bg-accent-100 text-accent-600',
  },
  {
    id: 2,
    title: '全终端无缝观影',
    desc: '电脑、平板、手机完美适配，进度同步，随时随地继续上次的观影之旅',
    icon: 'ri-smartphone-line',
    iconBg: 'bg-primary-100 text-primary-600',
  },
  {
    id: 3,
    title: '智能推荐引擎',
    desc: '基于观影偏好智能匹配，发现更多符合您口味的高分好片，告别剧荒烦恼',
    icon: 'ri-brain-line',
    iconBg: 'bg-secondary-100 text-secondary-600',
  },
  {
    id: 4,
    title: '安全稳定可靠',
    desc: '全站 HTTPS 加密传输，多重服务器保障，99.9% 服务可用率，观影视听无忧',
    icon: 'ri-lock-line',
    iconBg: 'bg-accent-100 text-accent-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm text-foreground-400 max-w-[500px] mx-auto">
            选择天堂影院的四大理由，让每一次观影都成为享受
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group flex flex-col items-center text-center p-5 md:p-6 rounded-lg bg-background-200/60 border border-background-200/50 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
            >
              <span className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full ${feature.iconBg} mb-4 transition-transform duration-300 group-hover:scale-110`}>
                <i className={`${feature.icon} text-xl md:text-2xl`}></i>
              </span>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-800 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-400 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}